module.exports = __webpack_public_path__ + "static/media/shop.9b886143.svg";